import OrganizerRequest from './OrganizerRequest';
import './organizer-request.scss'

export default OrganizerRequest;